/* global axios */
import ApiClient from './ApiClient';

// Top-level (NOT account-scoped) — the "what's new" pop-up is platform-wide.
class AnnouncementsAPI extends ApiClient {
  constructor() {
    super('announcements', { accountScoped: false });
  }

  // The latest published popup the current user hasn't dismissed (or null).
  active() {
    return axios.get(`${this.url}/active`);
  }

  // Mark a popup announcement seen so it never shows again.
  dismiss(id) {
    return axios.post(`${this.url}/${id}/dismiss`);
  }
}

export default new AnnouncementsAPI();
